import EncodingParametersInURL from "./EncodingParametersInURL";
import WorkingWithArrays from "./WorkingWithArrays";
import WorkingWithObjects from "./WorkingWithObjects";

function Assignment5() {
    return(
        <div>
            <h1>Assignment 5</h1>
            <a href="http://localhost:4000/a5/welcome">Welcome</a>
            <EncodingParametersInURL />
            <WorkingWithObjects />
            <WorkingWithArrays />
        </div>
    )
}

export default Assignment5;